import { createStore } from 'vuex';
import { reactive } from 'vue';

import sections_list from './modules/sections_list';
import sections_detail from './modules/sections_detail';
import sections_attachments from './modules/sections_attachments';
import analytics from './modules/analytics';

import evalvation from './modules/evalvation';
import evalvation_questionnaire from './modules/evalvation_questionnaire';
import evalvation_dashboard from './modules/evalvation_dashboard';

import ai from './modules/ai';

import users from './modules/users';
import auth from './modules/auth';

import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export const state = {
    
    // Data for popup modal
    modalVisible: false,
    modalWorkingVisible: false,
	modalComponent: null,
    modalData: null,
    
    // Db version (app version is injected at build time, see vue.config.js)
    db_version: null,

    // Loged in user data
    token: '',
    isAuthenticated: false,
    user: {},
    // Time in ms when login is about to expire
    expirationTime: 4 * 60 * 60 * 1000,


    // Faculty of logged user
    faculty: {},

    // All faculties
    faculties: {},
    sorted_faculties_by_acronym: [],
        
    // School year
    year: '',
    

    // All years (preserve structure due to usage at copy sections from previous year)
    years: {
        '2025/2026': '2025/2026',
        '2024/2025': '2024/2025',
        '2023/2024': '2023/2024',
        '2022/2023': '2022/2023',
        '2021/2022': '2021/2022',
        '2020/2021': '2020/2021',
        '2019/2020': '2019/2020',
        '2018/2019': '2018/2019',
    },

    // Date of new active year (months starts with 0!) - param choosen indicates if current choosen year meets active year standards
    // !!temporary disabled, only thing we need is active year, which we now set statically
    active_year_date: {month: 5, day: 1, active_year: '2025/2026'},

};

export const store = createStore({
    state,
	getters,
    mutations,
    actions,
    modules: {
        sections_list,
        sections_detail,
        sections_attachments,
        analytics,
        evalvation,
        evalvation_questionnaire,
        evalvation_dashboard,
        users,
        auth,
        ai
    }
});